module.exports = __webpack_public_path__ + "img/jurisdiction.af9dc21c.png";